<template>
  <div>
    <div class="container-group">
      <!-- Título -->
      <b-form-group
        :label="
          $t('evaluations.newEvaluations.titleOf', {
            entity: $getVisibleNames('evaluations2.rubric', false, 'Pauta'),
          })
        "
        label-for="input-name"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <b-form-input
          id="input-name"
          v-model="$v.rubric.title.$model"
          :state="validateState('title')"
          aria-describedby="input-name-feedback"
          size="sm"
        ></b-form-input>
        <b-form-invalid-feedback id="input-name-feedback">{{
          $t("reusable.common.required")
        }}</b-form-invalid-feedback>
      </b-form-group>

      <!-- Descripción -->
      <b-form-group
        :label="
          $t('evaluations.newEvaluations.descriptionOf', {
            entity: $getVisibleNames('evaluations2.rubric', false, 'Pauta'),
          })
        "
        label-for="input-description"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <div
          class="rubric-form-description mb-2"
          @click="$bvModal.show(`edit-rubric-description-modal-${rubric.id}`)"
        >
          <RenderVHtml
            v-b-tooltip.v-secondary.noninteractive.hover="{
              title: $t('evaluations.newEvaluations.editDescriptionOf', {
                entity: $getVisibleNames('evaluations2.rubric', false, 'Pauta'),
              }),
              boundary: 'viewport',
            }"
            :content="rubric.description"
          ></RenderVHtml>
        </div>
        <ContainerRichTextKlv3
          :id_modal="`edit-rubric-description-modal-${rubric.id}`"
          :title_modal="
            $t('evaluations.newEvaluations.editDescriptionOf', {
              entity: $getVisibleNames('evaluations2.rubric', false, 'Pauta'),
            })
          "
          :size_modal="`lg`"
          :object_rich_text="rubric"
          :content_rich_text="rubric.description"
          :show_last_modification="true"
          @save="(content) => patchRubric(rubric, content)"
          @close="$bvModal.hide(`edit-rubric-description-modal-${rubric.id}`)"
        >
        </ContainerRichTextKlv3>
        <!-- <b-modal
          :id="`edit-rubric-description-modal-${rubric.id}`"
          :title="`Editar Descripción de la ${$getVisibleNames(
            'evaluations2.rubric',
            false,
            'Pauta'
          )}`"
          size="lg"
          hide-footer
          ignore-enforce-focus-selector="#sidebar-right"
        >
          <NewRichTextEditor
            :Object="rubric"
            :Text="rubric.description"
            @save="patchRubric"
            @close="$bvModal.hide(`edit-rubric-description-modal-${rubric.id}`)"
          ></NewRichTextEditor>
        </b-modal> -->
        <b-form-invalid-feedback id="input-description-feedback">{{
          $t("evaluations.newEvaluations.optionalField")
        }}</b-form-invalid-feedback>
      </b-form-group>
      <!-- Tipo  -->
      <b-form-group
        v-if="!rubric.rubric_type_default && !rubricHasLevels"
        :label="`${$getVisibleNames(
          'evaluations2.rubricpreset',
          false,
          'Modelo de Pauta'
        )}`"
        label-for="select-type"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <div class="d-flex">
          <div class="d-block w-100">
            <b-form-select
              id="select-type"
              value-field="id"
              text-field="label"
              v-model="$v.rubric_type_default.preset.$model"
              @change="rubricTypePresetChoice"
              :state="validateStateType('preset')"
              :options="rubricPresetsOptions"
              aria-describedby="select-type-feedback"
              size="sm"
            ></b-form-select>
            <b-form-invalid-feedback id="select-type-feedback">{{
              $t("reusable.common.required")
            }}</b-form-invalid-feedback>
          </div>
          <div class="ml-1 mr-1 container-btn-presets" v-if="isNaN(rubric.id)">
            <b-button
              v-if="rubric_type_default.preset != null"
              size="sm"
              class="ml-1 p-0"
              variant="none"
              v-b-tooltip.top.noninteractive.v-secondary="
                $t('evaluations.newEvaluations.preview') +
                ' ' +
                $getVisibleNames(
                  'evaluations2.rubricpreset',
                  false,
                  'Modelo de Pauta'
                )
              "
              @click="
                $bvModal.show(`modal-view-rubric-preset-container-${test_id}`)
              "
            >
              <b-icon class="btn-actions" icon="eye" scale="1"></b-icon>
            </b-button>
            <button-add
              v-if="
                user &&
                (user.group_names.includes(
                  'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
                ) ||
                  user.is_superuser)
              "
              size="sm"
              class="ml-1 p-0"
              v-b-tooltip.top.noninteractive.v-secondary="
                $t('reusable.common.createTooltip', {
                  entity: $getVisibleNames(
                    'evaluations2.rubricpreset',
                    false,
                    'Modelo de Pauta'
                  ),
                })
              "
              @click="
                $bvModal.show(`modal-created-rubric-preset-form-${test_id}`)
              "
            ></button-add>
          </div>
        </div>
      </b-form-group>
      <!-- Nivel de Logro -->
      <b-form-group
        :label="
          $t('evaluations.newEvaluations.entityBy', {
            entity: $getVisibleNames(
              'evaluations.observationachievement',
              false,
              'Niveles de Logro'
            ),
          })
        "
        label-for="show_percentage_sign"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <b-form-select
          id="show_percentage_sign"
          v-model="$v.rubric.show_percentage_sign.$model"
          :state="validateState('show_percentage_sign')"
          :options="showPercentageSigns"
          value-field="value"
          text-field="label"
          aria-describedby="show_percentage_sign-feedback"
          size="sm"
        ></b-form-select>
        <b-form-invalid-feedback id="show_percentage_sign-feedback">{{
          $t("reusable.common.required")
        }}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :label="
          $t('evaluations.newEvaluations.addDescriptorTo', {
            entity: $getVisibleNames(
              'evaluations.observationachievement',
              false,
              'Niveles de Logro'
            ),
          })
        "
        label-for="allow_criteria_performance_level_input"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <b-form-select
          id="allow_criteria_performance_level_input"
          v-model="$v.rubric.allow_criteria_performance_level_input.$model"
          :state="validateState('allow_criteria_performance_level_input')"
          :options="showPerformanceLevelInput"
          value-field="value"
          text-field="label"
          aria-describedby="allow_criteria_performance_level_input-feedback"
          size="sm"
        ></b-form-select>
        <b-form-invalid-feedback
          id="allow_criteria_performance_level_input-feedback"
          >{{ $t("reusable.common.required") }}</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group
        v-if="
          evaluativeAgent &&
          (['duoc_coevaluacion_evaluative_agent'].includes(
            evaluativeAgent.internal_use_id
          ) ||
            $equals(evaluativeAgent.name, 'Coevaluación'))
        "
        label-for="input-evaluatee_can_see_coevaluator"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <template #label>
          <div class="block-title-container">
            <div>{{ $t("evaluations.newEvaluations.showCoevaluator") }}</div>
            <div class="ml-2">
              <InfoTooltip
                :tooltip_text="
                  $t('evaluations.newEvaluations.showsEvaluateeWhoEvaluated')
                "
              ></InfoTooltip>
            </div>
          </div>
        </template>
        <div>
          <b-form-checkbox
            class="mt-2"
            size="md"
            v-model="rubric.evaluatee_can_see_coevaluator"
          >
          </b-form-checkbox>
        </div>
      </b-form-group>
      <b-form-group
        v-if="
          evaluativeAgent &&
          (['duoc_coevaluacion_evaluative_agent'].includes(
            evaluativeAgent.internal_use_id
          ) ||
            $equals(evaluativeAgent.name, 'Coevaluación'))
        "
        label-for="input-evaluatee_can_see_coevaluator"
        label-cols="0"
        label-cols-sm="4"
        label-cols-md="4"
        class="m-0 p-0"
      >
        <template #label>
          <div class="block-title-container">
            <div>{{ $t("evaluations.newEvaluations.coevaluationType") }}</div>
            <div class="ml-2" v-if="!existEvaluateeTest">
              <InfoTooltip
                :tooltip_text="
                  $t('evaluations.newEvaluations.selectMultipleAllowsRepeated')
                "
              ></InfoTooltip>
            </div>
          </div>
        </template>
        <div v-if="!existEvaluateeTest">
          <b-form-select
            class="mt-1"
            id="select-type"
            value-field="id"
            text-field="value"
            v-model="$v.rubric.coevaluation_type.$model"
            :state="validateState('coevaluation_type')"
            :options="rubric_coevaluation_type_choices"
            aria-describedby="select-type-feedback"
            size="sm"
          ></b-form-select>
          <b-form-invalid-feedback id="select-type-feedback">{{
            $t("reusable.common.required")
          }}</b-form-invalid-feedback>
        </div>
        <div v-else class="ml-2 mt-2">
          {{
            (
              rubric_coevaluation_type_choices.find(
                (x) => x.id == rubric.coevaluation_type
              ) || {}
            ).value || ""
          }}
        </div>
      </b-form-group>
      <template v-if="institution && institution.internal_use_id != 'duoc.cl'">
        <b-form-group
          v-if="
            evaluativeAgent &&
            test &&
            test.student_can_auto_evaluate &&
            (['duoc_autoevaluacion_evaluative_agent'].includes(
              evaluativeAgent.internal_use_id
            ) ||
              $equals(evaluativeAgent.name, 'Autoevaluación'))
          "
          label-for="input-evaluate_autoevaluation"
          label-cols="0"
          label-cols-sm="4"
          label-cols-md="4"
          class="m-0 p-0"
        >
          <template #label>
            <div class="title-method">
              {{ $t("evaluations.newEvaluations.selectMethod") }}
            </div>
          </template>
        </b-form-group>
        <b-form-group
          v-if="
            evaluativeAgent &&
            test &&
            test.student_can_auto_evaluate &&
            (['duoc_autoevaluacion_evaluative_agent'].includes(
              evaluativeAgent.internal_use_id
            ) ||
              $equals(evaluativeAgent.name, 'Autoevaluación'))
          "
          label-for="input-evaluate_autoevaluation"
          label-cols="0"
          label-cols-sm="4"
          label-cols-md="4"
          class="m-0 p-0"
        >
          <template #label>
            <div class="block-title-container">
              <b-icon icon="dot" class="mt-1"></b-icon>
              <div>
                {{
                  $t("evaluations.newEvaluations.congruentSelfEvaluationMethod")
                }}
              </div>
              <div class="ml-2">
                <InfoTooltip
                  :tooltip_text="
                    $t('evaluations.newEvaluations.gradesDependOnCoincidence')
                  "
                ></InfoTooltip>
              </div>
            </div>
          </template>
          <div>
            <b-form-checkbox
              class="mt-2"
              size="md"
              v-model="rubric.evaluate_autoevaluation"
              @change="changeEvaluateeAutoevaluation"
            >
            </b-form-checkbox>
          </div>
        </b-form-group>
        <b-form-group
          v-if="
            evaluativeAgent &&
            !rubric.evaluate_autoevaluation &&
            ((test &&
              test.student_can_auto_evaluate &&
              (['duoc_autoevaluacion_evaluative_agent'].includes(
                evaluativeAgent.internal_use_id
              ) ||
                $equals(evaluativeAgent.name, 'Autoevaluación'))) ||
              ['duoc_coevaluacion_evaluative_agent'].includes(
                evaluativeAgent.internal_use_id
              ) ||
              $equals(evaluativeAgent.name, 'Coevaluación'))
          "
          label-for="input-student_weighing"
          label-cols="0"
          label-cols-sm="4"
          label-cols-md="4"
          class="m-0 p-0"
        >
          <template #label>
            <div class="block-title-container">
              <b-icon
                v-if="
                  evaluativeAgent &&
                  !rubric.evaluate_autoevaluation &&
                  (['duoc_autoevaluacion_evaluative_agent'].includes(
                    evaluativeAgent.internal_use_id
                  ) ||
                    $equals(evaluativeAgent.name, 'Autoevaluación'))
                "
                icon="dot"
                class="mt-1"
              ></b-icon>
              <div>
                {{ $t("evaluations.newEvaluations.weightedGradingMethod") }}
              </div>
              <div class="ml-2">
                <InfoTooltip
                  :tooltip_text="
                    $t(
                      'evaluations.newEvaluations.percentageIndicatesWeighting'
                    )
                  "
                ></InfoTooltip>
              </div>
            </div>
          </template>
          <b-form-input
            id="input-student_weighing"
            v-model="$v.rubric.student_weighing.$model"
            :state="validateState('student_weighing')"
            aria-describedby="input-student_weighing-feedback"
            size="sm"
            type="number"
          ></b-form-input>
          <RenderVHtml
            v-if="
              rubric.student_weighing >= 0 && rubric.student_weighing <= 100
            "
            class="mb-2 alert-student-weighing"
            :content="
              $t('evaluations.newEvaluations.studentWeightingMessage', {
                percentage: rubric.student_weighing,
                remaining: 100 - rubric.student_weighing,
              })
            "
          ></RenderVHtml>
          <b-form-invalid-feedback id="input-student_weighing-feedback">
            <span
              v-if="
                rubric.student_weighing > 100 || rubric.student_weighing < 0
              "
            >
              {{ $t("evaluations.newEvaluations.fieldMustBeBetween0And100") }}
            </span>
            <span v-else>
              {{ $t("evaluations.newEvaluations.fieldMustBePositiveInteger") }}
            </span>
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
      <b-modal
        :id="`modal-view-rubric-preset-container-${test_id}`"
        :title="$t('evaluations.newEvaluations.instrumentTypes')"
        size="xl"
        hide-footer
      >
        <RubricPresetPreview
          :rubric_preset_id="rubric_type_default.preset"
        ></RubricPresetPreview>
      </b-modal>
      <b-modal
        :id="`modal-created-rubric-preset-form-${test_id}`"
        :title="
          $t('reusable.common.createTooltip', {
            entity: $getVisibleNames(
              'evaluations2.rubricpreset',
              false,
              'Modelo de Pauta'
            ),
          })
        "
        size="lg"
        hide-footer
        ignore-enforce-focus-selector="#sidebar-right"
      >
        <!-- :RubricPreset="
            rubric_presets.find((x) => x.id == rubric_type_default.preset)
          " -->
        <RubricPresetForm
          :show_rubric_preset="true"
          @created="createdRubricPreset"
        ></RubricPresetForm>
      </b-modal>
      <b-form-group
        label-for="input-modification-date"
        label-cols="0"
        label-cols-sm="0"
        class="p-0 m-0 mt-2"
      >
        <ModificationDate :Information="rubric"></ModificationDate>
      </b-form-group>
      <div class="container-buttons">
        <b-button class="mr-1" size="sm" @click="saveRubric">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId, toast } from "../../../utils/utils";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  required,
  requiredIf,
  minValue,
  maxValue,
  integer,
} from "vuelidate/lib/validators";

export default {
  name: "NewRubricForm",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    RubricPresetPreview: () =>
      import("@/components/new-evaluations/Rubrics/RubricPresetPreview"),
    RubricPresetForm: () =>
      import(
        "@/components/new-evaluations/Rubrics/RubricsPreset/RubricPresetForm"
      ),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    test_id: {
      type: Number,
      required: true,
    },
    Rubric: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          title: "",
          description: "",
          test: this.test_id,
          show_percentage_sign: true,
          allow_criteria_performance_level_input: true,
          rubric_type_default: null,
          student_weighing: 0,
          coevaluation_type: 1,
          evaluate_autoevaluation: false,
          evaluatee_can_see_coevaluator: false,
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
  },
  data() {
    return {
      rubric: { ...this.Rubric },
      rubric_type_default: {
        id: generateUniqueId(),
        rubric: this.Rubric.id,
        preset: null,
      },
      rubric_coevaluation_type_choices: [
        {
          id: 1,
          value: this.$t("evaluations.newEvaluations.simpleCoevaluation"),
        },
        {
          id: 2,
          value: this.$t("evaluations.newEvaluations.multipleCoevaluation"),
        },
      ],
      showPercentageSigns: [
        {
          value: true,
          label: this.$t("evaluations.newEvaluations.percentage"),
        },
        {
          value: false,
          label: this.$t("evaluations.newEvaluations.score"),
        },
      ],
      showPerformanceLevelInput: [
        {
          value: true,
          label: this.$t("evaluations.newEvaluations.showDescriptors"),
        },
        {
          value: false,
          label: this.$t("evaluations.newEvaluations.hideDescriptors"),
        },
      ],
    };
  },
  validations: {
    rubric: {
      title: { required },
      description: {},
      coevaluation_type: {},
      show_percentage_sign: {},
      allow_criteria_performance_level_input: {},
      student_weighing: {
        required,
        minValue: minValue(0),
        integer,
        maxValue: maxValue(100),
      },
    },
    rubric_type_default: {
      preset: {
        // El modelo solo aporta niveles: si la pauta ya los tiene, no se pide
        required: requiredIf(function () {
          return !this.rubricHasLevels;
        }),
      },
    },
    validationGroup: ["rubric", "rubric_type_default"],
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
      rubric_presets: names.RUBRIC_PRESETS,
      evaluatee_tests: names.EVALUATEE_TESTS,
      rubric_preset_units: names.RUBRIC_PRESET_UNITS,
      rubric_achievements: names.NEW_RUBRIC_ACHIEVEMENTS,
      evaluatee_rubrics: names.EVALUATEE_RUBRICS,
      instrument_types: names.NEW_TEST_TYPES,
      new_tests: names.NEW_TESTS,
    }),
    test() {
      return this.new_tests.find((x) => x.id == this.test_id);
    },
    evaluativeAgent() {
      if (!this.test) return null;
      return this.instrument_types.find(
        (x) => x.id == this.test.evaluative_agent
      );
    },
    rubricPresetsOptions() {
      return this.rubric_presets.map((x) => ({
        ...x,
        label:
          x.title +
          " - " +
          this.$getVisibleNames(
            "evaluations.observationachievement",
            true,
            "Niveles de Logro"
          ) +
          ": " +
          this.rubric_preset_units.filter((a) => a.rubric_preset == x.id)
            .length,
      }));
    },
    existEvaluateeTest() {
      if (
        this.evaluatee_tests.filter(
          (x) =>
            x.test == this.test_id &&
            (x.start_time != null ||
              x.is_corrected ||
              x.finished_at ||
              x.is_published)
        ).length > 0
      )
        return true;
      else return false;
    },
    rubricHasLevels() {
      return (
        !isNaN(this.rubric.id) &&
        this.rubric_achievements.some((x) => x.rubric == this.rubric.id)
      );
    },
    evaluateeRubrics() {
      return this.evaluatee_rubrics.filter(
        (x) => x.rubric == this.rubric.id && x.coevaluators.length > 1
      );
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.rubric[name];
      return $dirty ? !$error : null;
    },
    validateStateType(name) {
      const { $dirty, $error } = this.$v.rubric_type_default[name];
      return $dirty ? !$error : null;
    },
    changeEvaluateeAutoevaluation(value) {
      if (value) {
        this.rubric.student_weighing = 0;
      }
    },
    patchRubric(object, text) {
      this.rubric.description = text;
    },
    rubricTypePresetChoice(value) {
      const rubric_preset = this.rubric_presets.find((x) => x.id == value);
      if (rubric_preset) {
        this.rubric.show_percentage_sign = rubric_preset.show_percentage_sign;
        this.rubric.allow_criteria_performance_level_input =
          rubric_preset.allow_criteria_performance_level_input;
      }
    },
    createdRubricPreset(response) {
      this.rubric_type_default.preset = response.id;
      this.$bvModal.hide(`modal-created-rubric-preset-form-${this.test_id}`);
    },
    saveRubric() {
      this.$v.validationGroup.$touch();
      if (this.$v.validationGroup.$anyError) {
        return;
      }
      if (
        this.evaluateeRubrics.length > 0 &&
        this.rubric.coevaluation_type == 1
      ) {
        this.$swal({
          title: `<p>${this.$t(
            "evaluations.newEvaluations.sureToSaveEntityWithMultipleCoevaluated",
            {
              entity: this.$getVisibleNames(
                "evaluations2.rubric",
                false,
                "Pauta"
              ),
            }
          )}</p>`,
          text: this.$t(
            "evaluations.newEvaluations.actionCannotBeRevertedCoevaluatorsReset"
          ),
          type: "warning",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            if (!isNaN(this.rubric.id))
              this.$restful
                .Post(`/evaluations2/unassign_rubric_coevaluators/`, {
                  rubric: this.rubric.id,
                })
                .then(() => {
                  this.$store
                    .dispatch(names.FETCH_EVALUATEE_RUBRICS, {
                      test_id: this.test_id,
                    })
                    .then(() => {
                      if (isNaN(this.rubric.id)) this.createRubric();
                      else this.updateRubric();
                      this.$emit("reset_rubric_coevaluators");
                      toast(
                        this.$t(
                          "evaluations.newEvaluations.evaluateesUnassignedSuccessfully"
                        )
                      );
                    });
                });
          }
        });
      } else {
        if (isNaN(this.rubric.id)) this.createRubric();
        else this.updateRubric();
      }
    },
    createRubric() {
      this.$store
        .dispatch(names.POST_NEW_RUBRIC_INSTRUMENT, this.rubric)
        .then((response) => {
          this.rubric = response;
          this.rubric_type_default.rubric = response.id;
          toast(
            this.$t("evaluations.newEvaluations.entityCreated", {
              entity: this.$getVisibleNames(
                "evaluations2.rubric",
                false,
                "Pauta"
              ),
            })
          );
          this.$store.dispatch(names.FETCH_NEW_TEST, {
            test_id: this.test_id,
            forceFetch: true,
          });
          this.saveRubricTypeDefault(response);
        });
    },
    updateRubric() {
      this.$store
        .dispatch(names.UPDATE_NEW_RUBRIC_INSTRUMENT, this.rubric)
        .then((response) => {
          this.rubric = response;
          this.rubric_type_default.rubric = response.id;
          toast(
            this.$t("evaluations.newEvaluations.entityEdited", {
              entity: this.$getVisibleNames(
                "evaluations2.rubric",
                false,
                "Pauta"
              ),
            })
          );
          this.saveRubricTypeDefault(response);
        });
    },
    saveRubricTypeDefault(saved_rubric) {
      if (saved_rubric.rubric_type_default != null)
        this.updateRubricTypeDefault();
      else if (this.rubric_type_default.preset != null)
        this.createRubricTypeDefault();
      // Pauta con niveles y sin modelo: se guarda tal cual, sin asociarle uno
      else this.$emit("closeModal", this.rubric);
    },
    createRubricTypeDefault() {
      // Los niveles del modelo solo se agregan a una pauta que aún no tiene
      const add_preset_levels = !this.rubricHasLevels;
      this.$restful
        .Post("/evaluations2/rubric-type-default/", this.rubric_type_default)
        .then((response) => {
          if (add_preset_levels)
            this.rubric_preset_units
              .filter((x) => x.rubric_preset == response.preset)
              .forEach((element) => {
                this.$store.dispatch(names.POST_NEW_RUBRIC_ACHIEVEMENT, {
                  title: element.title,
                  description: element.description,
                  order: element.order,
                  score: element.score,
                  rubric: response.rubric,
                });
              });
          this.$store.commit(
            "MUTATE_CHANGE_NEW_RUBRIC_TYPE_BY_NEW_RUBRIC",
            response
          );
          this.rubric_type_default = response;
          this.$emit("closeModal", this.rubric);
        });
    },
    updateRubricTypeDefault() {
      this.$restful
        .Put(
          `/evaluations2/rubric-type-default/${this.rubric_type_default.id}/`,
          this.rubric_type_default
        )
        .then((response) => {
          this.$store.commit(
            "MUTATE_CHANGE_NEW_RUBRIC_TYPE_BY_NEW_RUBRIC",
            response
          );
          this.rubric_type_default = response;
          this.$emit("closeModal", this.rubric);
        });
    },
    fetchRubricTypeDefault() {
      if (this.rubric.rubric_type_default != null) {
        this.$restful
          .Get(
            `/evaluations2/rubric-type-default/${this.rubric.rubric_type_default}/`
          )
          .then((response) => {
            this.rubric_type_default = response;
          });
      }
    },
  },
  mounted() {
    if (this.institution && this.institution.internal_use_id == "duoc.cl") {
      this.rubric.evaluate_autoevaluation = false;
      this.rubric.student_weighing = 100;
    }
    if (
      this.test &&
      !this.test.student_can_auto_evaluate &&
      this.evaluativeAgent &&
      (["duoc_autoevaluacion_evaluative_agent"].includes(
        this.evaluativeAgent.internal_use_id
      ) ||
        this.$equals(this.evaluativeAgent.name, "Autoevaluación"))
    ) {
      this.rubric.student_weighing = 0;
      this.rubric.evaluate_autoevaluation = false;
    }
  },
  created() {
    this.fetchRubricTypeDefault();
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scoped>
.alert-student-weighing {
  font-size: 10pt;
}
.title-method {
  text-decoration: underline;
}
.block-title-container {
  display: flex;
  justify-content: space-between;
}
.container-btn-presets {
  display: flex;
  flex-direction: row;
}
.container-group {
  margin-top: 0%;
}
.container-buttons {
  display: flex;
  justify-content: right;
}
.rubric-form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.25rem 1.2rem;
  line-height: 1.5;
}
.rubric-form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>